import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { toastOnError, isEmpty } from '../../utils/Utils';



const initialState = {
    ops: {},
    filter: 1,
    isLoading: false, 
    issues: [],
    op: {}
}


export const getOperations = createAsyncThunk(
    'ops/bookings',
    async (user, {dispatch, rejectWithValue}) => {
        try {
            const response = await axios.get('/ops/operations/');
            dispatch(setOperations(response.data));
            return response.data
        } catch (error) {
            toastOnError(error);
            return rejectWithValue(error.response.data);
        }
    }
)


export const getOperation = createAsyncThunk(
    'ops/bookings/op',
    async (opId, {dispatch, rejectWithValue}) => {
        try {
            const response = await axios.get(`/ops/operation/${opId}/`);
            dispatch(setOperation(response.data));
            return response.data
        } catch (error) {
            toastOnError(error);
            return rejectWithValue(error.response.data);
        }
    }
)


export const updateOperation = createAsyncThunk(
    'ops/update',
    async (opData, {dispatch, rejectWithValue}) => {
        try {
            const response = await axios.patch(`/ops/operations/${opData.id}/`, opData);
            dispatch(updateOps(response.data));
            toast.success('Operation updated');
            return response.data
        } catch (error) {
            toastOnError(error);
            return rejectWithValue(error.response.data);
        }
    }
)


export const checkIntegrity = createAsyncThunk(
    'admin/integrity',
    async (_, {dispatch, rejectWithValue}) => {
        try {
            console.log('calling integrity')
            const response = await axios.get('/admin/integrity/')
            if (isEmpty(response.data)) {
                toast.success('No issues found');
            } else {
                dispatch(setIssues(response.data));
            }
            return response.data;
        } catch (error) {
            toastOnError(error);
            return rejectWithValue(error.response.data);
        }
    }
)


const operationsSlice = createSlice({
    name: 'operations',
    initialState,
    reducers: {
        setOperations (state, action) {
            state.ops = action.payload;
        },
        unsetOperations (state) {
            state.ops = {};
        },
        updateOps (state, action) {
            const updatedOp = action.payload;
            const ops = state.ops;
            state.ops = ops.map((op) => op.id === updatedOp.id ? {...op, ...updatedOp} : op)
        },
        setFilter (state, action) {
            state.filter = action.payload;
        },
        setIssues (state, action) {
            state.issues = action.payload;
        },
        resetIssues (state, _) {
            state.issues = []
        },
        setOperation (state, action) {
            state.op = action.payload;
        },
        unsetOperation (state, _) {
            state.op = {}
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getOperations.pending, (state) => {
            state.isLoading = true;
        }).addCase(getOperations.fulfilled, (state) => {
            state.isLoading = false;
        }).addCase(getOperations.rejected, (state) => {
            state.isLoading = false;
        }).addCase(updateOperation.pending, (state) => {
            state.isLoading = true;
        }).addCase(updateOperation.fulfilled, (state) => {
            state.isLoading = false;
        }).addCase(updateOperation.rejected, (state) => {
            state.isLoading = false;
        }).addCase(getOperation.pending, (state) => {
            state.isLoading = true;
        }).addCase(getOperation.fulfilled, (state) => {
            state.isLoading = false;
        }).addCase(getOperation.rejected, (state) => {
            state.isLoading = false;
        })
    }
})

export const { setOperations, unsetOperations, updateOps, setFilter, setIssues, resetIssues, setOperation, unsetOperation } = operationsSlice.actions;
export default operationsSlice.reducer;